<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">密钥信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div style="padding-left: 5%;padding-top:26px;">
        <SForm
          ref="formref"
          :fields="formfields"
          :data-form="rowdata"
          :before="formbefore"
          label-width="180px"
          :is-show-btn="false"
          form-style="width:96%"
          label-position="left"
        />
      </div>
    </el-card>
  </div>
</template>
<script>
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'Miyaoxiangqing',
  components: {},
  data() {
    return {
      rowdata: {},
      formfields: [
        {
          label: '企业类型',
          type: 'div',
          style: 'width:100%',
          prop: 'orgType'
        },
        {
          label: '企业名称',
          type: 'div',
          style: 'width:100%',
          prop: 'name'
        },
        {
          label: '企业密钥',
          type: 'div',
          style: 'width:100%',
          prop: 'orgKey'
        },
        {
          label: '消息密钥',
          type: 'div',
          style: 'width:100%',
          prop: 'smsKey'
        },
        {
          label: '初始化向量',
          type: 'div',
          style: 'width:100%',
          prop: 'initVector'
        },
        {
          label: '签名密钥',
          type: 'div',
          style: 'width:100%',
          prop: 'signKey'
        },
        {
          label: '流量方接口url',
          type: 'div',
          style: 'width:100%',
          prop: 'url'
        },
        {
          label: '是否对账',
          type: 'div',
          style: 'width:100%',
          prop: 'reconciliation'
        }
      ],
      formbefore: record => {
        console.log(record)
        return record
      },
      id: ''

    }
  },
  computed: {
  },
  mounted() {
    this.getDetail()
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    getDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/setting/getDataDetail',
        data: data,
        method: 'get',
        callback: resp => {
          this.rowdata = resp
          if (this.rowdata.reconciliation) {
            this.rowdata.reconciliation = '是'
          } else {
            this.rowdata.reconciliation = '否'
          }
          if (this.rowdata.orgType == 0) {
            this.rowdata.orgType = '互联互通运营商'
          } else if (this.rowdata.orgType == 1) {
            this.rowdata.orgType = '流量方'
          } else {
            this.rowdata.orgType = '监管平台'
          }
        }
      })
    },
    cancel() {
      this.$router.go(-1)
    },

    save() {

    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
 }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/views/systemManagement/secretKeyDetail.vue